export default __webpack_public_path__ + "static/lech-am-arlberg-austria-0153fa347c7607883069e26b98bcf8a3.jpg";